<!-- eslint-disable -->

<template>
  <div
    v-show="show"
    id="voice-icon"
    class="absolute top-1500px left-0 right-0  flex justify-center"
  >
    <div
      class="flex w-full justify-center"
    >
      <div
        class="px-19px flex  items-center justify-center"
      >
        <div class="relative h-32px px-19px">
          <!-- <img
            v-if="!isIOS"
            src="./imgs/left.svg"
            class="h-35px absolute bottom-0 left-0 z-2"
          > -->
          <div
            class="relative h-32px mt-5px relative z-3 bg-[#59B5EA] rounded-55px flex items-center justify-center px-16px with-shadow"
            @click="showVisible"
          >
            <!-- <div
              v-if="!isIOS"
              class="bg-[#F8F8F8] z-[-1] absolute left-13px right-13px h-6px top-[-6px]"
            /> -->
            <span class="c-muli-bold ml-8px text-[#fff] text-12px">{{ _ct_('voice_comment') || 'Voice Comment' }}</span>
          </div>
          
          <!-- <img
            v-if="!isIOS"
            src="./imgs/right.svg"
            class="h-35px absolute bottom-0 right-0 z-2 "
          > -->
        </div>
      </div>
    </div>
    <!-- <div
      v-if="!isIOS"
      class="bg-[#F8F8F8] h-6px"
    /> -->
  </div>
  <c-popup
    v-model:show="permissionVisible"
    closeable
    class="p-24px !pt-40px"
    position="center"
    :style="{ width: '80%' }"
  >
    <div class="text-16px text-center c-muli-bold">
      {{ _ct_('voice_requestweb') || 'Enable microphone permission' }}
    </div>
    <div class="text-14px  text-center c-muli text-[#1f1f1f] mt-8px mb-24px">
      {{ _ct_('voice_requestwebtext') || 'Click the Allow Notifications switch on the right to turn it on.' }}
    </div>
    <c-button
      type="primary"
      class="w-full"
      @click="permissionVisible = false"
    >
      {{ _ct_('voice_requestwebbutton') || 'OK' }}
    </c-button>
  </c-popup>
  <c-popup
    v-model:show="tipVisible"
    closeable
    class="p-24px"
    position="center"
  >
    <div class="c-muli-semibold text-14px !leading-18px">
      {{ _ct_('voice_comfirm') || 'Currently there is evaluation content, enter the voice comment will clear all text comments, whether to continue?' }}
    </div>
    <div class="flex justify-center mt-24px">
      <c-button
        class="!mr-9px"
        @click="tipVisible = false"
      >
        {{ _ct_('voice_comfirmbutton1') || 'CANCEL' }}
      </c-button>
      <c-button
        type="primary"
        @click="showVoiceVisible"
      >
        {{ _ct_('voice_comfirmbutton2') || 'CONFIRM' }}
      </c-button>
    </div>
  </c-popup>
  <c-popup
    v-if="visible"
    v-model:show="visible"
    teleport="body"
    closeable
    class="voice-popup"
    position="bottom"
    :style="{ height: '60%' }"
  >
    <VoicePop
      :maxlength="maxlength"
      @saveText="saveText"
      @handleDenied="handleDenied"
    />
  </c-popup>
</template>
<script>
/* eslint-disable */
import { defineComponent, ref } from 'vue';
import VoicePop from './VoicePop.vue';

export default defineComponent({
  components: {
    VoicePop
  },
  props: {
    email: {
      type: String
    },
    itemValue: {
      type: String
    },
    show: {
      type: Boolean
    },
    maxlength: {
      type: Number
    },
    isIOS: {
      type: Boolean

    }
  },
  emits: ['saveText', 'selfClick'],
  setup (props, {emit}) {
    const visible = ref(false);
    const tipVisible = ref(false);
    const permissionVisible = ref(false);
    const showVisible = () => {
      emit('selfClick', false);
      if (props.itemValue) {
        tipVisible.value = true;
        return;
      }
      visible.value = true;
      window.cps?.('event', {
        event_name: "vioce_to_word",
        event_category: "write_review",
        event_action: "view",
        event_label: {},
        event_params: {}
      });
    };
    const showVoiceVisible = () => {
      tipVisible.value = false;
      visible.value = true;
      window.cps?.('event', {
        event_name: "vioce_to_word",
        event_category: "write_review",
        event_action: "view",
        event_label: {},
        event_params: {}
      });
    };
    const handleDenied = ()=> {
      tipVisible.value = false;
      permissionVisible.value = true;
      visible.value = false;
    };
    
    return {
      _ct_: window._ct_ || function() {},
      permissionVisible,
      handleDenied,
      tipVisible,
      visible,
      showVisible,
      showVoiceVisible,
      saveText (sufix) {
        visible.value = false;
        emit('saveText', sufix);
      }
    };
  },
});
</script>

<style>
.voice-popup {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
#voice-icon.absolute  {
  /* padding-bottom: env(safe-area-inset-bottom);
  background: linear-gradient(to bottom, 
    transparent 0%, 
    transparent 32px, 
    #f8f8f8 32px, 
    #f8f8f8 100%
  ); */
  transition: top 0.05s ease;
}
#voice-icon.fixed{
  transition: bottom 0.01s ease;
}
#voice-icon .with-shadow{
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
}
  
</style>